import React from "react";
import {
  FormField,
  FormInput,
  FormTextarea,
  Modal,
  ModalFooterButtons,
} from "../../../../components/Modal";

export interface AddLocationDialogProps {
  open: boolean;
  onClose: () => void;
  handleAddLocation: () => void;
  addingLocation: boolean;
  locationForm: {
    title: string;
    addressLines: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
  };
  setLocationForm: React.Dispatch<
    React.SetStateAction<{
      title: string;
      addressLines: string;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    }>
  >;
}

export function AddLocationDialog({
  open,
  onClose,
  handleAddLocation,
  addingLocation,
  locationForm,
  setLocationForm,
}: AddLocationDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Add Location"
      description="Define an office, data center, or cloud region"
      size="sm"
      footer={
        <ModalFooterButtons
          onCancel={onClose}
          onSubmit={handleAddLocation}
          submitLabel={addingLocation ? "Saving" : "Save"}
          submitDisabled={!locationForm.title || addingLocation}
        />
      }
    >
      <FormField label="Title" required>
        <FormInput
          placeholder="e.g. AWS US-East-1 Region"
          value={locationForm.title}
          onChange={(v) => setLocationForm((f) => ({ ...f, title: v }))}
        />
      </FormField>
      <FormField label="Address Lines" hint="One per line">
        <FormTextarea
          placeholder="100 Technology Drive"
          value={locationForm.addressLines}
          onChange={(v) =>
            setLocationForm((f) => ({ ...f, addressLines: v }))
          }
          rows={2}
        />
      </FormField>
      <div className="grid grid-cols-2 gap-3">
        <FormField label="City">
          <FormInput
            placeholder="Arlington"
            value={locationForm.city}
            onChange={(v) => setLocationForm((f) => ({ ...f, city: v }))}
          />
        </FormField>
        <FormField label="State">
          <FormInput
            placeholder="VA"
            value={locationForm.state}
            onChange={(v) => setLocationForm((f) => ({ ...f, state: v }))}
          />
        </FormField>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <FormField label="Postal Code">
          <FormInput
            type="number"
            placeholder="22201"
            value={locationForm.postalCode}
            onChange={(v) =>
              setLocationForm((f) => ({ ...f, postalCode: v }))
            }
          />
        </FormField>
        <FormField label="Country">
          <FormInput
            placeholder="US"
            value={locationForm.country}
            onChange={(v) => setLocationForm((f) => ({ ...f, country: v }))}
          />
        </FormField>
      </div>
    </Modal>
  );
}
